import React from "react";
import PropTypes from 'prop-types';
import ReactPlayer from "react-player/lazy";
import "../../styles/style.scss"
function VideoScreen({ currentVideo }) {
    

            // <video ref={videoRef} className="card-img-top" controls preload="metadata">
            //     {/* El elemento source se añade de forma dinámica*/}
            // </video>
    return (
        <div className="card h-100">
            <ReactPlayer url={currentVideo.url} controls={true} fallback={<div className="thumbnail" />}  light={<div className="thumbnail" />} />
            <div className="card-body">
                <h5 className="card-title">{currentVideo.name}</h5>
            </div>
        </div>
    );
}

VideoScreen.propTypes = {
    currentVideo: PropTypes.shape({
        url: PropTypes.string,
        name: PropTypes.string
    })
};

export default VideoScreen;